import { NavLink, Navigate, Route, Routes } from 'react-router-dom';
import {
  Bell,
  Building2,
  Mail,
  Palette,
  Settings as SettingsIcon,
  Shield,
  Sliders,
  FileText,
} from 'lucide-react';
import { TenantInfoTab } from './settings-tabs/TenantInfoTab';
import { BrandingTab } from './settings-tabs/BrandingTab';
import { SecurityPolicyTab } from './settings-tabs/SecurityPolicyTab';
import { EmailConfigTab } from './settings-tabs/EmailConfigTab';
import { EmailTemplatesTab } from './settings-tabs/EmailTemplatesTab';
import { GeneralSettingsTab } from './settings-tabs/GeneralSettingsTab';

/**
 * Page hub `/admin/parametres` — Phase 6 (US-ADM-01/05/06/07/09 + US-TR-06).
 *
 * Onglets accessibles via sous-routes :
 *  - /admin/parametres/etablissement → US-ADM-01 (infos, adresse, logo, contact)
 *  - /admin/parametres/theme         → US-TR-06 (couleurs primary/secondary/accent)
 *  - /admin/parametres/securite      → US-ADM-05 (politique mdp + sessions + lockout)
 *  - /admin/parametres/emails        → US-ADM-06 (Resend config + test)
 *  - /admin/parametres/modeles       → US-ADM-07 (templates Handlebars CRUD)
 *  - /admin/parametres/general       → US-ADM-09 (numérotation, workflows, constantes, délais)
 */

const TABS = [
  { to: '/admin/parametres/etablissement', label: 'Établissement', icon: Building2 },
  { to: '/admin/parametres/theme', label: 'Thème', icon: Palette },
  { to: '/admin/parametres/securite', label: 'Sécurité', icon: Shield },
  { to: '/admin/parametres/emails', label: 'Emails', icon: Mail },
  { to: '/admin/parametres/modeles', label: 'Modèles emails', icon: FileText },
  { to: '/admin/parametres/general', label: 'Général', icon: Sliders },
];

export function AdminSettingsPage() {
  return (
    <div className="max-w-7xl mx-auto space-y-4">
      <h1 className="text-2xl font-bold text-gray-900 flex items-center">
        <SettingsIcon className="w-7 h-7 mr-2 text-primary-600" />
        Paramètres
      </h1>

      {/* Onglets horizontaux + scroll mobile */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
        <nav className="flex overflow-x-auto border-b border-gray-200">
          {TABS.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              className={({ isActive }) =>
                `flex items-center px-4 py-3 text-sm font-medium whitespace-nowrap border-b-2 transition-colors ${
                  isActive
                    ? 'text-primary-600 border-primary-500 bg-primary-50/50'
                    : 'text-gray-600 border-transparent hover:text-gray-900 hover:bg-gray-50'
                }`
              }
            >
              <t.icon className="w-4 h-4 mr-2" />
              {t.label}
            </NavLink>
          ))}
        </nav>

        <div className="p-4 sm:p-6">
          <Routes>
            <Route index element={<Navigate to="etablissement" replace />} />
            <Route path="etablissement" element={<TenantInfoTab />} />
            <Route path="theme" element={<BrandingTab />} />
            <Route path="securite" element={<SecurityPolicyTab />} />
            <Route path="emails" element={<EmailConfigTab />} />
            <Route path="modeles" element={<EmailTemplatesTab />} />
            <Route path="general" element={<GeneralSettingsTab />} />
            <Route path="*" element={<Navigate to="etablissement" replace />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}

void Bell;
